import {
  ImportCsvModal,
  validationUtil
} from 'iron-forge-react-modules';

import { OrderPropertyName } from 'generated/graphql';



export const propertyName2Comment: Record<OrderPropertyName, string> = {
  order_shippingMethod: 'order_shippingMethod',
  order_id: 'order_id',
  order_identifier: 'order_identifier',
  order_date: 'order_date',
  order_promotionType: 'order_promotionType',

  customer_fullName: 'customer_fullName',
  customer_firstName: 'customer_firstName',
  customer_lastName: 'customer_lastName',
  customer_email: 'customer_email',
  customer_phoneNumber: 'customer_phoneNumber',

  billingAddress_company: 'billingAddress_company',
  billingAddress_street1: 'billingAddress_street1',
  billingAddress_street2: 'billingAddress_street2',
  billingAddress_city: 'billingAddress_city',
  billingAddress_postalCode: 'billingAddress_postalCode',
  billingAddress_usStateAbbrev: 'billingAddress_usStateAbbrev',
  billingAddress_countryCode: 'billingAddress_countryCode',

  shippingAddress_company: 'shippingAddress_company',
  shippingAddress_street1: 'shippingAddress_street1',
  shippingAddress_street2: 'shippingAddress_street2',
  shippingAddress_city: 'shippingAddress_city',
  shippingAddress_postalCode: 'shippingAddress_postalCode',
  shippingAddress_usStateAbbrev: 'shippingAddress_usStateAbbrev',
  shippingAddress_countryCode: 'shippingAddress_countryCode',

  lineItem_sku: 'lineItem_sku',
  lineItem_quantity: 'lineItem_quantity',
  lineItem_itemTotalDollars: 'lineItem_itemTotalDollars',
  lineItem_taxTotalDollars: 'lineItem_taxTotalDollars',
  lineItem_feeTotalDollars: 'lineItem_feeTotalDollars',
  lineItem_lineTotalDollars: '',
  lineItem_pricePaidDollars: 'lineItem_pricePaidDollars',
  lineItem_iccid: '',
  lineItem_imei: '',
  lineItem_productName: '',

  order_dateShipped: '',
  order_paymentMethod: '',
  order_shippingCarrier: '',
  order_totalDollars: '',
  order_trackingNumber: '',
  order_shippingTotalDollars: '',
  other_unboundProperty: '',

  customField_1: 'Custom Field 1',
  customField_2: 'Custom Field 2',
  customField_3: 'Custom Field 3',
  customField_4: 'Custom Field 4',
  customField_5: 'Custom Field 5',
  customField_6: 'Custom Field 6',
  customField_7: 'Custom Field 7',
  customField_8: 'Custom Field 8',
  customField_9: 'Custom Field 9',
  customField_10: 'Custom Field 10',
  customField_11: 'Custom Field 11',
  customField_12: 'Custom Field 12',
  customField_13: 'Custom Field 13',
  customField_14: 'Custom Field 14',
  customField_15: 'Custom Field 15',
  customField_16: 'Custom Field 16',
  customField_17: 'Custom Field 17',
  customField_18: 'Custom Field 18',
  customField_19: 'Custom Field 19',
  customField_20: 'Custom Field 20'
};



export const propertyName2Data: Record<OrderPropertyName, ImportCsvModal.IFormatTypeData> = {
  billingAddress_company: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  billingAddress_countryCode: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  order_shippingMethod: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  shippingAddress_company: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  shippingAddress_countryCode: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  order_id: {
    example: "A UUID",
    properFormat: "",
    fnValidate: val => validationUtil.reUuid.test(val)
  },
  order_shippingTotalDollars: {
    example: "Shipping total",
    properFormat: "0.00",
    fnValidate: () => true
  },
  other_unboundProperty: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  order_identifier: {
    example: "MMO_12345",
    properFormat: "",
    fnValidate: val => val.length <= 25
  },
  order_date: {
    example: "20230401",
    properFormat: "",
    fnValidate: () => true
  },
  order_promotionType: {
    example: "",
    properFormat: '',
    fnValidate: () => false
  },
  customer_fullName: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  customer_firstName: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  customer_lastName: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  customer_email: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  customer_phoneNumber: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  billingAddress_street1: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  billingAddress_street2: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  billingAddress_city: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  billingAddress_postalCode: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  billingAddress_usStateAbbrev: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  shippingAddress_street1: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  shippingAddress_street2: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  shippingAddress_city: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  shippingAddress_postalCode: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  shippingAddress_usStateAbbrev: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_sku: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_quantity: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_feeTotalDollars: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_itemTotalDollars: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_lineTotalDollars: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_taxTotalDollars: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_pricePaidDollars: {
    example: "",
    properFormat: "",
    fnValidate: () => true
  },
  lineItem_iccid: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  lineItem_imei: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  lineItem_productName: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  order_dateShipped: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  order_paymentMethod: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  order_shippingCarrier: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  order_totalDollars: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  order_trackingNumber: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_1: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_2: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_3: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_4: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_5: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_6: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_7: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_8: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_9: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_10: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_11: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_12: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_13: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_14: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_15: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_16: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_17: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_18: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_19: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  },
  customField_20: {
    example: '',
    properFormat: '',
    fnValidate: () => true
  }
};
